import { DependencyList, EffectCallback, useLayoutEffect, useRef } from "react";

const useDidMountEffect = (callback: EffectCallback, deps?: DependencyList) => {
  const didMount = useRef(false);

  useLayoutEffect(() => {
    if (didMount.current) callback();
    else didMount.current = true;
  }, deps);
};

export default useDidMountEffect;
